import clean from 'lodash-clean';
import get from 'lodash/get';

import i18n from 'shared/lib/i18n';

import {
  CANCEL_NEW_CHAT_CREATION_REQUESTED,
  CHECK_DOCUMENT_EXISTING_THREAD_FAILURE,
  CHECK_DOCUMENT_EXISTING_THREAD_REQUEST,
  CHECK_DOCUMENT_EXISTING_THREAD_SUCCESS,
  CHECK_DOCUMENT_NEW_THREAD_FAILURE,
  CHECK_DOCUMENT_NEW_THREAD_REQUEST,
  CHECK_DOCUMENT_NEW_THREAD_SUCCESS,
  CLEAR_CHATS_REQUESTED,
  CLEAR_RECIPIENTS_REQUESTED,
  CREATE_THREAD_FAILURE,
  CREATE_THREAD_REQUESTED,
  CREATE_THREAD_SUCCESS,
  DROP_MESSAGES,
  GET_CHATS_FAILURE,
  GET_CHATS_REQUESTED,
  GET_CHATS_SUCCESS,
  GET_CHAT_BY_ID_FAILURE,
  GET_CHAT_BY_ID_REQUESTED,
  GET_CHAT_BY_ID_SUCCESS,
  GET_CHAT_INFO_BY_ID_FAILURE,
  GET_CHAT_INFO_BY_ID_REQUEST,
  GET_CHAT_INFO_BY_ID_SUCCESS,
  GET_NUMBER_OF_RECIPIENTS_FAILURE,
  GET_NUMBER_OF_RECIPIENTS_REQUESTED,
  GET_NUMBER_OF_RECIPIENTS_SUCCESS,
  GET_RECIPIENTS_FAILURE,
  GET_RECIPIENTS_REQUESTED,
  GET_RECIPIENTS_SUCCESS,
  GET_ROLES_FAILURE,
  GET_ROLES_REQUESTED,
  GET_ROLES_SUCCESS,
  GET_THREADS_SCOPES_FAILURE,
  GET_THREADS_SCOPES_REQUEST,
  GET_THREADS_SCOPES_SUCCESS,
  HANDLE_NEW_CHAT_CREATION_REQUESTED,
  MARK_CHAT_AS_READ_FAILURE,
  MARK_CHAT_AS_READ_REQUESTED,
  MARK_CHAT_AS_READ_SUCCESS,
  PRELOAD_DOCUMENT_FAILURE,
  PRELOAD_DOCUMENT_REQUEST,
  PRELOAD_DOCUMENT_SUCCESS,
  PUT_NEW_MESSAGE_FAILURE,
  PUT_NEW_MESSAGE_REQUESTED,
  PUT_NEW_MESSAGE_SUCCESS,
  SET_CURRENT_CHAT_ID,
  SET_DOCUMENT_AS_ATTACHMENT,
  SET_MODAL_TYPE,
  SET_NEW_MESSAGE_TEXT,
  SET_NEW_SELECT_VALUE,
} from '../../../actionConstants';
import { getDashboardInfo } from '../../Shared/actions';

import { formatDate, isAdmin, isToday, isWithinAWeek } from '../../../utils';

import apiClient from '../../../apiClient';
import { defaultDateFormat } from '../../../staticData';
import { CONFIRM } from '../../Modal/modalTypes';

export const getChats = (dispatch, queryParams, withReset) =>
  dispatch({
    type: GET_CHATS_REQUESTED,
    payload: apiClient.messages.getThreads(queryParams).then(
      (res) => {
        dispatch({
          type: GET_CHATS_SUCCESS,
          payload: res,
          withReset,
        });
        return res;
      },
      (err) =>
        dispatch({
          type: GET_CHATS_FAILURE,
          err,
        }),
    ),
  });

export const getChatInfoById = (dispatch, chatId, props) => {
  const selectValue = props?.selectValue?.value;
  const buildingId = props?.match?.params?.buildingId;
  const building =
    buildingId ?? (typeof selectValue === 'number' ? selectValue : undefined);
  const queryParams = { id: chatId, building };
  return dispatch({
    type: GET_CHAT_INFO_BY_ID_REQUEST,
    payload: apiClient.messages.getThreads(clean(queryParams)).then(
      (res) => {
        dispatch({
          type: GET_CHAT_INFO_BY_ID_SUCCESS,
          res,
          chatId,
        });
        return res;
      },
      (err) =>
        dispatch({
          type: GET_CHAT_INFO_BY_ID_FAILURE,
          err,
        }),
    ),
  });
};

export const clearChats = (dispatch) =>
  dispatch({
    type: CLEAR_CHATS_REQUESTED,
  });

export const clearRecipients = (dispatch) =>
  dispatch({
    type: CLEAR_RECIPIENTS_REQUESTED,
  });

export const getChatById = (dispatch, chatId, queryParams) =>
  dispatch({
    type: GET_CHAT_BY_ID_REQUESTED,
    payload: apiClient.messages.getChatById(chatId, queryParams).then(
      (res) => {
        dispatch({
          type: GET_CHAT_BY_ID_SUCCESS,
          payload: res,
        });
        return res;
      },
      (err) =>
        dispatch({
          type: GET_CHAT_BY_ID_FAILURE,
          err,
        }),
    ),
  });

export const markChatAsRead = (dispatch, chatId) => {
  if (isAdmin()) return null;
  return dispatch({
    type: MARK_CHAT_AS_READ_REQUESTED,
    payload: apiClient.messages.markChatAsRead(chatId).then(
      () => {
        dispatch({
          type: MARK_CHAT_AS_READ_SUCCESS,
          payload: chatId,
        });
        getDashboardInfo(dispatch, true);
      },
      (err) =>
        dispatch({
          type: MARK_CHAT_AS_READ_FAILURE,
          err,
        }),
    ),
  });
};

export const putNewMessage = (dispatch, threadId, data) =>
  dispatch({
    type: PUT_NEW_MESSAGE_REQUESTED,
    payload: apiClient.messages.putNewMessage(threadId, data).then(
      (res) =>
        dispatch({
          type: PUT_NEW_MESSAGE_SUCCESS,
          payload: res,
        }),
      (err) =>
        dispatch({
          type: PUT_NEW_MESSAGE_FAILURE,
          err,
        }),
    ),
  });

export const handleNewChatCreation = (dispatch, data) =>
  dispatch({
    type: HANDLE_NEW_CHAT_CREATION_REQUESTED,
    payload: data,
  });

export const cancelNewChatCreation = (dispatch) =>
  dispatch({
    type: CANCEL_NEW_CHAT_CREATION_REQUESTED,
  });

export const getRecipients = (dispatch, queryParams = { limit: 10 }) =>
  dispatch({
    type: GET_RECIPIENTS_REQUESTED,
    payload: apiClient.messages.getRecipients(queryParams).then(
      (res) =>
        dispatch({
          type: GET_RECIPIENTS_SUCCESS,
          payload: res,
        }),
      (err) =>
        dispatch({
          type: GET_RECIPIENTS_FAILURE,
          err,
        }),
    ),
  });

export const getThreadsScopes = (dispatch) =>
  dispatch({
    type: GET_THREADS_SCOPES_REQUEST,
    payload: apiClient.messages.getThreadsScopes().then(
      (res) => {
        dispatch({
          type: GET_THREADS_SCOPES_SUCCESS,
          res,
        });
        return res;
      },
      (err) =>
        dispatch({
          type: GET_THREADS_SCOPES_FAILURE,
          err,
        }),
    ),
  });

export const createThread = (dispatch, data) =>
  dispatch({
    type: CREATE_THREAD_REQUESTED,
    payload: apiClient.messages.createThread(clean(data)).then(
      (res) => {
        dispatch({
          type: CREATE_THREAD_SUCCESS,
          payload: res,
        });
        return res?.data?.threadIds;
      },
      (err) =>
        dispatch({
          type: CREATE_THREAD_FAILURE,
          err,
        }),
    ),
  });

export const getNumberOfRecipients = (dispatch, { groups, recipients }) => {
  const data = clean({ groups, recipients });
  return dispatch({
    type: GET_NUMBER_OF_RECIPIENTS_REQUESTED,
    payload: apiClient.messages.getNumberOfRecipients(data).then(
      (res) =>
        dispatch({
          type: GET_NUMBER_OF_RECIPIENTS_SUCCESS,
          payload: res,
        }),
      (err) =>
        dispatch({
          type: GET_NUMBER_OF_RECIPIENTS_FAILURE,
          err,
        }),
    ),
  });
};

export const getRoles = (dispatch) =>
  dispatch({
    type: GET_ROLES_REQUESTED,
    payload: apiClient.messages.getRoles().then(
      (res) =>
        dispatch({
          type: GET_ROLES_SUCCESS,
          payload: res,
        }),
      (err) =>
        dispatch({
          type: GET_ROLES_FAILURE,
          err,
        }),
    ),
  });

export const preuploadDocument = (dispatch, data) =>
  dispatch({
    type: PRELOAD_DOCUMENT_REQUEST,
    payload: apiClient.messages.preuploadDocument(data).then(
      (res) => {
        dispatch({
          type: PRELOAD_DOCUMENT_SUCCESS,
          successMessage: i18n.t('popup.documentPreUploaded'),
        });
        return res;
      },
      (err) =>
        dispatch({
          type: PRELOAD_DOCUMENT_FAILURE,
          err,
        }),
    ),
  });

export const checkDocumentNewThread = (dispatch, data) =>
  dispatch({
    type: CHECK_DOCUMENT_NEW_THREAD_REQUEST,
    payload: apiClient.messages.checkDocumentNewThread(clean(data)).then(
      (res) => {
        dispatch({
          type: CHECK_DOCUMENT_NEW_THREAD_SUCCESS,
        });
        return res;
      },
      (err) =>
        dispatch({
          type: CHECK_DOCUMENT_NEW_THREAD_FAILURE,
          err,
        }),
    ),
  });

export const checkDocumentExistingThread = (dispatch, data, threadId) =>
  dispatch({
    type: CHECK_DOCUMENT_EXISTING_THREAD_REQUEST,
    payload: apiClient.messages
      .checkDocumentExistingThread(data, threadId)
      .then(
        (res) => {
          dispatch({
            type: CHECK_DOCUMENT_EXISTING_THREAD_SUCCESS,
          });
          return res;
        },
        (err) =>
          dispatch({
            type: CHECK_DOCUMENT_EXISTING_THREAD_FAILURE,
            err,
          }),
      ),
  });

export const setNewSelectValue = (dispatch, value) =>
  dispatch({
    type: SET_NEW_SELECT_VALUE,
    value,
  });

export const setCurrentChatId = (dispatch, id) =>
  dispatch({
    type: SET_CURRENT_CHAT_ID,
    id,
  });

export const promptForReply = (dispatch, message) => {
  const { sender } = message;
  const personName = `${get(sender, 'firstName')} ${get(sender, 'lastName')}`;
  const personId = get(sender, 'id');
  const data = {
    messageTo: [personName],
    recipients: [personId],
    numberOfRecipients: 1,
    isReply: true,
    person: sender,
  };
  handleNewChatCreation(dispatch, data);
};

export const getFormattedDate = (date) => {
  if (!date) return null;
  let format = defaultDateFormat;
  if (isToday(date)) {
    format = 'hh:mm a';
  } else if (isWithinAWeek(date)) {
    format = 'dddd';
  } else {
    format = 'MMM D YYYY';
  }
  return formatDate(date, true, format);
};

export const setDocumentAsAttachment = (dispatch, documentId, documentName) =>
  dispatch({
    type: SET_DOCUMENT_AS_ATTACHMENT,
    documentId,
    documentName,
  });

export const setNewMessageText = (dispatch, text) =>
  dispatch({
    type: SET_NEW_MESSAGE_TEXT,
    text,
  });

export const confirmSendingDocumentOnly = (
  dispatch,
  sendDocumentOnly,
  attachmentDocumentName,
) => {
  const modalProps = {
    bodyText: i18n.t('messages.attachmentNote', {
      document: attachmentDocumentName,
    }),
    onConfirm: () => {},
    onCancel: () => sendDocumentOnly(),
    confirmText: i18n.t('actions.addText'),
    cancelText: i18n.t('actions.continue'),
  };
  return dispatch({
    type: SET_MODAL_TYPE,
    modalType: CONFIRM,
    modalProps,
  });
};

export const confirmSendingMultiRecipients = (
  dispatch,
  recipientsCount,
  onSendMessage,
) => {
  const modalProps = {
    bodyText: i18n.t('messages.sendRecipients', {
      recipients: recipientsCount,
    }),
    onConfirm: () => onSendMessage(),
    onCancel: () => {},
    confirmText: i18n.t('actions.send'),
    cancelText: i18n.t('actions.cancel'),
  };
  return dispatch({
    type: SET_MODAL_TYPE,
    modalType: CONFIRM,
    modalProps,
  });
};

export const dropMessages = (dispatch) => dispatch({ type: DROP_MESSAGES });
